import artworkFrag from "./Artwork";
import EditionType from "./EditionType";

const Edition = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    // Associations
    artwork = false,
    type = false,
    // Scalar fields
    ap = includeDefaults,
    availableNumbers = includeDefaults,
    year = includeDefaults,
    number = includeDefaults,
  } = propsObj;

  return `
  id
  ${ap ? "ap" : ""}
  ${
    artwork
      ? `artwork {
      ${artworkFrag(artwork)}
    }`
      : ""
  }
  ${availableNumbers ? "availableNumbers" : ""}
  ${number ? "number" : ""}
  ${
    type
      ? `type {
      ${EditionType}
    }`
      : ""
  }
  ${year ? "year" : ""}
`;
};

export default Edition;
